// c:\xampp\htdocs\miners-market-main\utils\useIntersectionObserver.js

import React from 'react';

export function useIntersectionObserver(ref, onIntersect, options = { threshold: 0.1 }) {
    React.useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // When the element is intersecting (visible)
                if (entry.isIntersecting) {
                    onIntersect();
                    // Stop observing after it has been seen once to prevent multiple triggers
                    observer.unobserve(element);
                }
            },
            options
        );

        observer.observe(element);

        // Cleanup function to disconnect the observer when the component unmounts
        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [ref, onIntersect, options]);
}

